import React from "react";
import { ArrowRight } from "lucide-react";

/** "Welcome back, Jane" — one tap puts last time's business and contact details back. Never shown to anyone else's device. */
export function WelcomeBack({ me, onUse, onForget }) {
  const first = (me.applicant_name || "").trim().split(/\s+/)[0] || "there";
  const initials = (me.applicant_name || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  return (
    <div className="rounded-2xl border border-[#0055FF]/20 bg-gradient-to-br from-[#EEF4FF] to-white p-4 sm:p-5 animate-in fade-in-0 slide-in-from-top-2 duration-300"
         data-testid="apply-welcome-back">
      <div className="flex items-start gap-3.5">
        <span className="grid place-items-center size-11 shrink-0 rounded-full bg-[#0055FF] text-white text-[14px] font-bold tracking-wide">{initials}</span>
        <div className="min-w-0 flex-1">
          <div className="text-[15.5px] font-bold text-[#0B1220]" data-testid="apply-welcome-name">Welcome back, {first}</div>
          <div className="mt-0.5 text-[13px] text-slate-600 truncate">
            Use your details from last time? <span className="font-semibold text-slate-800">{me.business_name}</span>
            {me.applicant_email && <span className="text-slate-500"> · {me.applicant_email}</span>}
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2">
            <button type="button" onClick={onUse} data-testid="apply-welcome-use"
                    className="inline-flex items-center gap-2 h-10 px-5 rounded-full bg-[#0055FF] hover:bg-[#0044CC] active:scale-[.98] text-white text-[13.5px] font-semibold transition-[background-color,transform] duration-150">
              Use my details <ArrowRight className="size-4" />
            </button>
            <button type="button" onClick={onForget} data-testid="apply-welcome-forget"
                    className="text-[13px] font-medium text-slate-500 hover:text-slate-800 underline-offset-2 hover:underline">
              Not you? Start fresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeBack;
